<template>
  <div class="logincontainer">
    <!-- PC端登录 -->
    <div class="login pc-login">
      <!-- PC端代码 -->
      <div style="font-size: 20px;font-weight: bold;color: #be0033;">
        <img src="./logo.png" alt="" @click="goBack" style="width: 130px;">
      </div>
      <div class="login-flex">
        <div class="right-image-container"><img src="./图片1.png" alt="安迅数智" class="right-image"></div>
        <div class="login-import">
          <!-- 登录方式切换 -->
          <div class="login-title">
            <div :class="{ 'login-act': loginType === 'sms' }" @click="changeLoginType('sms')">短信登录</div>
            <div :class="{ 'login-act': loginType === 'email' }" @click="changeLoginType('email')">邮箱登录</div>
          </div>
          <!-- 邮箱手机号登录 -->
          <div class="login-email" v-if="loginType === 'email'">
            <div class="login-inp">
              <div><input type="email" v-model="emailForm.account" placeholder="请输入邮箱账号"
                  @keydown.enter="handleEmailLogin" />
              </div>
              <div class="login-cen">
                <div><input type="text" v-model="emailForm.captcha" id="captcha"
                    :placeholder="emailCaptcha.countdown > 0 ? `${emailCaptcha.countdown}s 后重新获取` : '请输入验证码'" /></div>
                <div><button :disabled="emailCaptcha.isSending" id="btn" type="button" @click="getCaptcha">
                    {{ emailCaptcha.isSending ? '已发送验证码' : (emailCaptcha.countdown > 0 ? `${emailCaptcha.countdown}秒后重试` : '获取验证码') }}
                  </button></div>
              </div>
            </div>
            <div class="login-bot">
            </div>
            <div class="login-but"><button style="color: #fff;" @click="handleEmailLogin">登录</button></div>
            <!-- <div class="pwsRed" style="text-align: center !important;">*为了更好地响应您的需求，在线业务联系，请您完善个人单位信息</div> -->
          </div>
          <!-- 手机号验证码登录 -->
          <div class="login-email" v-if="loginType === 'sms'">
            <div class="login-inp">
              <div><input type="text" v-model="smsForm.phone" id="phone" placeholder="请输入手机号"
                  @keydown.enter="handleSmsLogin" />
              </div>
              <div class="login-cen">
                <div><input type="text" v-model="smsForm.captcha" id="captcha"
                    :placeholder="smsCaptcha.countdown > 0 ? `${smsCaptcha.countdown}s 后重新获取` : '请输入验证码'" /></div>
                <div><button :disabled="smsCaptcha.isSending" id="btn" type="button" @click="getCaptcha">
                    {{ smsCaptcha.isSending ? '已发送验证码' : (smsCaptcha.countdown > 0 ? `${smsCaptcha.countdown}秒后重试` : '获取验证码') }}
                  </button></div>
              </div>
            </div>
            <div class="login-bot">
            </div>
            <div class="login-but"><button style="color: #fff;" @click="handleSmsLogin">登录</button></div>
            <!-- <div class="pwsRed" style="text-align: center !important;">*为了更好地响应您的需求，在线业务联系，请您完善个人单位信息</div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端代码 -->
    <div class="mobile-login">
      <div class="mobile-header">
        <img src="./logo.png" alt="安迅数智" @click="goBack" class="mobile-logo">
      </div>

      <div class="mobile-login-container">
        <div class="mobile-login-title">
          <div :class="{ 'mobile-login-act': loginType === 'sms' }" @click="changeLoginType('sms')">短信登录</div>
          <div :class="{ 'mobile-login-act': loginType === 'email' }" @click="changeLoginType('email')">邮箱登录
          </div>
        </div>

        <!-- 邮箱登录表单 -->
        <div class="mobile-login-form" v-if="loginType === 'email'">
          <div class="mobile-input-group">
            <input type="email" v-model="emailForm.account" placeholder="请输入邮箱账号">
          </div>
          <div class="mobile-input-group mobile-captcha-group">
            <input type="text" v-model="emailForm.captcha"
              :placeholder="emailCaptcha.countdown > 0 ? `${emailCaptcha.countdown }s 后重新获取` : '请输入验证码'">
            <!-- <button class="mobile-captcha-btn" :disabled="!canGetCaptcha" @click="getCaptcha"> -->
            <button class="mobile-captcha-btn" :disabled="emailCaptcha.isSending" @click="getCaptcha">
              <!-- {{ captchaCountdown > 0 ? `${captchaCountdown}秒后重试` : '获取验证码' }} -->
              {{ emailCaptcha.isSending ? '已发送验证码' : (emailCaptcha.countdown > 0 ? `${emailCaptcha.countdown }秒后重试` : '获取验证码') }}
            </button>
          </div>
          <button class="mobile-login-btn" @click="handleEmailLogin">登录</button>
        </div>

        <!-- 短信登录表单 -->
        <div class="mobile-login-form" v-if="loginType === 'sms'">
          <div class="mobile-input-group">
            <input type="tel" v-model="smsForm.phone" placeholder="请输入手机号">
          </div>
          <div class="mobile-input-group mobile-captcha-group">
            <input type="text" v-model="smsForm.captcha"
              :placeholder="smsCaptcha.countdown > 0 ? `${smsCaptcha.countdown}s 后重新获取` : '请输入验证码'">
            <button class="mobile-captcha-btn" :disabled="smsCaptcha.isSending" @click="getCaptcha">
              <!-- {{ captchaCountdown > 0 ? `${captchaCountdown}秒后重试` : '获取验证码' }} -->
              {{ smsCaptcha.isSending ? '已发送验证码' : (smsCaptcha.countdown > 0 ? `${smsCaptcha.countdown}秒后重试` : '获取验证码') }}
            </button>
          </div>
          <button class="mobile-login-btn" @click="handleSmsLogin">登录</button>
        </div>
        <!-- <div class="mobile-notice">
          *为了更好地响应您的需求，在线业务联系，请您完善个人单位信息
        </div> -->
         <div class="mobile-right-image-container"><img src="./图片1.png" alt="安迅数智" class="mobile-right-image"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import Fingerprint2 from "fingerprintjs2";
import { getsms, loginsms, getemail, loginemail } from '@/api/login'
// import axios from 'axios'; // 引入axios
export default {
  data() {
    return {
      loginType: 'sms', // 默认显示短信登录
      emailForm: {
        account: '',
        captcha: ''
      },
      smsForm: {
        phone: '',
        captcha: ''
      },
        // 为每种登录方式单独设置状态
    smsCaptcha: {
      countdown: 0,
      isSending: false
    },
    emailCaptcha: {
      countdown: 0,
      isSending: false
    }
    }
  },
  mounted() {
    let murmur;
    let that = this; 
      var options = {
      excludes: {
        enumerateDevices: true,
        platform: true,
        addBehavior: true,
        cpuClass: true,
        deviceMemory: true,
        hardwareConcurrency: true,
        colorDepth: true,
        screenResolution: true,
        availableScreenResolution: true,
        indexedDb: true,
        webgl: true,
        plugins: true,
        canvas: true,
        pixelRatio: true,
      },
    };
    console.log(options, "options"); // 获取浏览器指纹
        Fingerprint2.get(options, (components) => {
      const values = components.map(function (component, index) {
        if (index === 0) {
          return component.value.replace(/\bNetType\/\w+\b/, "");
        }
        return component.value;
      });
      murmur = Fingerprint2.x64hash128(values.join(""), 31);
      that.murmur = murmur;
      localStorage.setItem("murmur", murmur);
      console.log(murmur, "loginnew新加的浏览器标识");
    });
  },
  computed: {
    canGetCaptcha() {
      if (this.loginType === 'sms') {
        return /^1[3-9]\d{9}$/.test(this.smsForm.phone) &&
          this.smsCaptcha.countdown === 0 &&
          !this.smsCaptcha.isSending;
      } else {
        return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(this.emailForm.account) &&
          this.emailCaptcha.countdown === 0 &&
          !this.emailCaptcha.isSending;
      }
    }
  },
  methods: {
    changeLoginType(type) {
      this.loginType = type
    },
    handleEmailLogin() {
      if (!this.emailForm.account) {
        Message.warning('请输入邮箱账号')
        return
      }
      if (!this.emailForm.captcha) {
        Message.warning('请输入验证码')
        return
      }
      // 邮箱登录逻辑
      loginemail({ gptsUserEmail: this.emailForm.account, code: this.emailForm.captcha ,
        browserId:localStorage.getItem('murmur')}).then(res => {
        if (res.code === 200) {
          Message.success({
            message: '登录成功',
            duration: 1000
          })
          console.log(res.data, "打印返回值")
          this.emailForm.account = ''
          this.emailForm.captcha = '';// 清空输入框
          localStorage.setItem('gptsUserId', res.data.gptsUserId)
          localStorage.setItem('token', res.data.token)
          console.log(localStorage.getItem('token'), "打印token")
          localStorage.setItem('gptsUserName', res.data.gptsUserName)
          console.log(localStorage.getItem('gptsUserId'), localStorage.getItem('gptsUserName'), "打印返回值111")
                //  this.syncAuthToOilgas(res.data.token);
          this.$router.push('/')
        } else {
          Message.error(res.msg)
        }
      })
    },
    handleSmsLogin() {
      if (!this.smsForm.phone) {
        Message.warning('请输入手机号')
        return
      }
      if (!this.smsForm.captcha) {
        Message.warning('请输入验证码')
        return
      }
      // 短信登录逻辑
      loginsms({ gptsUserPhone: this.smsForm.phone, code: this.smsForm.captcha,
        browserId:localStorage.getItem('murmur')
       }).then(res => {
        if (res.code === 200) {
         Message.success({
            message: '登录成功',
            duration: 1000
         })
          this.smsForm.phone = ''
          this.smsForm.captcha = ''
          localStorage.setItem('gptsUserId', res.data.gptsUserId)
          localStorage.setItem('token', res.data.token)
          console.log(localStorage.getItem('token'), "打印token")
          localStorage.setItem('gptsUserName', res.data.gptsUserName)
          console.log(localStorage.getItem('gptsUserId'), localStorage.getItem('gptsUserName'), "打印返回值111")
            // this.syncAuthToOilgas(res.data.token);
          this.$router.push('/')
        } else {
          Message.error(res.msg)
        }
      })
    },
    getCaptcha() {
  if (!this.canGetCaptcha) {
    Message.warning(this.loginType === 'sms' ? '请输入正确的手机号' : '请输入正确的邮箱账号');
    return;
  }

  // 根据登录类型设置状态
  if (this.loginType === 'sms') {
    this.smsCaptcha.isSending = true;
    this.smsCaptcha.countdown = 120;
  } else {
    this.emailCaptcha.isSending = true;
    this.emailCaptcha.countdown = 120;
  }

  const timer = setInterval(() => {
    if (this.loginType === 'sms') {
      this.smsCaptcha.countdown--;
      if (this.smsCaptcha.countdown <= 0) {
        clearInterval(timer);
        this.smsCaptcha.isSending = false;
      }
    } else {
      this.emailCaptcha.countdown--;
      if (this.emailCaptcha.countdown <= 0) {
        clearInterval(timer);
        this.emailCaptcha.isSending = false;
      }
    }
  }, 1000);

  // 发送验证码逻辑（保持不变）
  const api = this.loginType === 'sms' ? 
    getsms({ phone: this.smsForm.phone }) : 
    getemail({ email: this.emailForm.account });

  api.then(res => {
    if (res.code === 200) Message.success('验证码已发送!');
  }).catch(() => {
    clearInterval(timer);
    if (this.loginType === 'sms') {
      this.smsCaptcha.countdown = 0;
      this.smsCaptcha.isSending = false;
    } else {
      this.emailCaptcha.countdown = 0;
      this.emailCaptcha.isSending = false;
    }
    Message.error('验证码发送失败');
  });
},
  // syncAuthToOilgas(token) {
  //   axios.post('https://www.oilgasinfoai.com/getInfo', {
  //     token
  //   },{
  //       withCredentials: true,
  //       headers: {
  //           'Content-Type': 'application/json',
  //           'Authorization': `Bearer ${token}`  // 推荐使用 Authorization 头
  //       }
  //   })
  //   .then(res => {
  //     console.log('同步成功:', res.data);
  //   })
  //   .catch(err => {
  //     console.error('同步失败:', err);
  //   });
  // },
    // getCaptcha() {
    //   if (!this.canGetCaptcha){
    //     if(this.loginType === 'sms'){
    //       Message.warning('请输入正确的手机号')
    //     }else{
    //       Message.warning('请输入正确的邮箱账号')
    //     }
    //     return
    //   }
    //   // 设置验证码已发送状态
    //   this.isCaptchaSend = true;
    //   this.captchaCountdown = 120;// 设置倒计时时间为2分钟
    //   const timer = setInterval(() => {
    //     this.captchaCountdown--
    //     if (this.captchaCountdown <= 0) {
    //       clearInterval(timer)
    //       this.isCaptchaSend = false; // 倒计时结束重置状态
    //     }
    //   }, 1000)

    //   // 发送短信验证码逻辑
    //   if (this.loginType === 'sms') {
    //     getsms({ phone: this.smsForm.phone }).then(res => {
    //       if (res.code === 200) {
    //         Message.success('验证码已发送!')
    //       }
    //     }).catch(() => {
    //       clearInterval(timer); // 发送失败时清除定时器
    //       this.captchaCountdown = 0; // 重置倒计时
    //       this.isCaptchaSend = false; // 重置发送状态
    //       Message.error('验证码发送失败');
    //     }
    //     )
    //   }
    //   // 发送邮箱验证码逻辑
    //   else if (this.loginType === 'email') {
    //     getemail({ email: this.emailForm.account }).then(res => {
    //       if (res.code === 200) {
    //         Message.success('验证码已发送!')
    //       }
    //     }).catch(() => {
    //       clearInterval(timer); // 发送失败时清除定时器
    //       this.captchaCountdown = 0; // 重置倒计时
    //       this.isCaptchaSend = false; // 重置发送状态
    //       Message.error('验证码发送失败');
    //     })
    //   }
    // },
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
/* 原有PC端样式保持不变 */
.logincontainer{
  width: 100%;
}
/* 基础样式 */
.login {
  max-width: 1400px;
  min-width: 320px; /* 修改为适应移动端的最小宽度 */
  width: 100%;
  margin: 0 auto;
  padding: 20px 15px 0;
  box-sizing: border-box;
}

/* 登录主体布局 */
.login-flex {
  display: flex;
  /* flex-wrap: wrap; */
  margin: 90px 0 0;
  align-items: center;
  justify-content: center; /* 居中显示 */
  gap: 20px;
  width: 100%;
}

/* 右侧图片容器 */
.right-image-container {
  flex: 1;
  min-width: 300px; /* 设置最小宽度 */
  max-width: 750px; /* 设置最大宽度 */
  display: flex;
  border-radius: 16px;
  overflow: hidden; /* 确保图片圆角不溢出 */
  justify-content: center;
  align-items: center;
}

.right-image {
  width: 100%;
  height: auto; /* 高度自适应 */
  max-height: 445px;
    border-radius: 16px; /* 比容器稍小，形成层次感 */
  object-fit: contain;
  margin-top: 0;
}

/* 登录表单容器 */
.login-import {
  /* flex: 1; */
  min-width: 300px; /* 设置最小宽度 */
  max-width: 580px; /* 设置最大宽度 */
  height: auto; /* 高度自适应 */
  /* min-height: 390px; */
  background: #FFFFFF;
  box-shadow: 0px 1px 18px 0px rgba(190, 190, 190, 0.52);
  text-align: center;
  padding: 10px 35px 15px;
  box-sizing: border-box;
  border-radius: 12px;
}

/* 登录标题 */
.login-title {
  cursor: pointer;
  display: flex;
  gap: 30px;
  color: #666;
  font-size: 18px;
  padding: 15px 0 10px;
  text-transform: uppercase;
  /* justify-content: center;
  flex-wrap: wrap;  */
}

.login-title .login-act {
  color: #BE0022;
  position: relative;
}

.login-title .login-act:after {
  content: '';
  position: absolute;
  bottom: -25%;
  left: 0;
  background: #BE0022;
  width: 100%;
  height: 4px;
}

/* 登录表单输入框 */
.login-email .login-inp input {
  width: 100%;
  /* max-width: 495px; */
  max-width: 430px;
  height: 55px;
  border: 2px solid #D3D3D3;
  margin-top: 20px;
  padding-left: 15px;
  font-size: 16px;
  color: #333;
   border-radius: 12px;
  /* box-sizing: border-box; */
}

.login-cen {
  display: flex;
  /* flex-wrap: wrap;  */
  gap: 30px; /* 添加间距 */
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.login-cen input,
.login-cen button {
  margin-top: 0 !important;
  flex: 1;
  min-width: 200px; /* 设置最小宽度 */
}

/* 验证码输入框 */
#captcha {
  width: 100%;
  max-width: 281px;
}

/* 登录按钮 */
.login-but button {
  width: 100%;
  max-width: 515px;
  height: 64px;
  background: #BE0022;
  border: 0;
  color: #FFFFFF;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  cursor: pointer;
   border-radius: 12px;
}

/* 获取验证码按钮 */
#btn {
  width: 100%;
  max-width: 200px;
  height: 57px;
  background: #BE0022;
  border: 2px solid #BE0022;
  color: #fff;
  cursor: pointer;
   border-radius: 12px;
}

/* 禁用状态样式 */
#btn:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  color: #fff;
}

/* 提示文字 */
.pwsRed {
  text-align: center !important;
  margin-top: 20px;
  font-size: 14px;
  color: #BE0022
}
/* .login {
  max-width: 1400px;
  min-width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
}

.login .login-flex {
  display: flex;
  margin: 25px 0 0;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-left: -60px;
}

.right-image-container {
  flex: 0 0 auto;
}

.right-image {
  width: 750px;
  height: 445px;
  margin-top: 33px;
}
.right-image img {
  object-fit: contain;
}
.login .login-import {
  width: 580px;
  height: 390px;
  background: #FFFFFF;
  box-shadow: 0px 1px 18px 0px rgba(190, 190, 190, 0.5200);
  text-align: center;
  padding: 0 35px;
}

.login-email:not(:last-child) {
  display: none;
}

.login .login-title {
  cursor: pointer;
  display: flex;
  gap: 30px;
  color: #666;
  font-size: 18px;
  padding: 15px 0 10px 0;
  text-transform: uppercase;
}

.login .login-title .login-act {
  color: #BE0022;
  position: relative;
}

.login .login-title .login-act:after {
  content: '';
  position: absolute;
  bottom: -25%;
  left: 0;
  background: #BE0022;
  width: 100%;
  height: 4px;
}

.login .login-email .login-inp input {
  width: 495px;
  height: 55px;
  border: 2px solid #D3D3D3;
  margin-top: 20px;
  padding-left: 15px;
  font-size: 16px;
  color: #333;
}

.login .login-email .login-bot {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #0D1D76;
  padding: 15px 0 25px 0;
  cursor: pointer;
}

.login .login-email .login-bot a {
  color: #0D1D76;
}

.login .login-email .login-but button {
  width: 515px;
  height: 64px;
  background: #BE0022;
  border: 0;
  color: #FFFFFF;
  text-transform: uppercase;
  font-size: 18px;
}

#num {
  width: 270px;
  height: 64px;
  border: 2px solid #D3D3D3;
}

#captcha {
  width: 281px;
}


.login .login-cen {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.login .login-cen input,
.login .login-cen button {
  margin-top: 0 !important;
}

.mio-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  transition: all 0.3s ease-in-out;
  opacity: 1;
  visibility: visible;
  width: 100%;
  height: 100%;
  display: none;
}

.mio-modal-mask .pop {
  width: 600px;
  padding: 15px 15px 35px 0;
  position: fixed;
  left: 32%;
  top: 22%;
  background: #FFFFFF;
}

.mio-modal-mask .pop .pop_img {
  text-align: right;
}

.mio-modal-mask .pop .pop_img img {
  cursor: pointer;
}

.mio-modal-mask .pop .pop_title {
  text-align: center;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: bold;
}

.mio-modal-mask .pop input {
  width: 400px;
  height: 46px;
  border: 1px solid #EEEEEE;
  border-radius: 5px;
  padding-left: 50px;
}

.mio-modal-mask .pop form div {
  text-align: center;
  margin-top: 25px;
}

.mio-modal-mask .pop .pop-email input {
  background: url(./xin.png)no-repeat left center;
  background-position: 4%;
}

.mio-modal-mask .pop .pop-num {
  position: relative;
}

.mio-modal-mask .pop .pop-pos {
  position: absolute;
  top: -30%;
  right: 15%;
}

.mio-modal-mask .pop .pop-pos button {
  width: 130px;
  height: 30px;
  background: #BE0022;
  border-radius: 15px;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
}

.mio-modal-mask .pop .pop-num input {
  background: url(./an.png)no-repeat left center;
  background-position: 4%;
}

.mio-modal-mask .pop .pop-pas input {
  background: url(./suo.png)no-repeat left center;
  background-position: 4%;
}

.mio-modal-mask .pop .pop-pass input {
  background: url(./suo.png)no-repeat left center;
  background-position: 4%;
}

.mio-modal-mask .pop .pop-but {
  text-align: center;
  margin-top: 50px;
}

.mio-modal-mask .pop .pop-but button {
  width: 450px;
  border: none;
  text-transform: uppercase;
  color: #FFFFFF;
  height: 46px;
  background: #BE0022;
  border-radius: 23px;
}

#btn {
  width: 200px;
  height: 57px;
  background: #BE0022;
  border: 2px solid #BE0022;
  color: #fff;
  margin-top: 19px;
  cursor: pointer;
}

#btn:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  color: #fff;
} */

/* 移动端样式 */
@media screen and (max-width: 768px) {
  .pc-login {
    display: none;
  }

  .mobile-login {
    display: block;
    padding: 20px;
    background-color: #fff;
    min-height: 100vh;
  }

  .mobile-header {
    text-align: center;
    padding: 30px 0;
  }

  .mobile-logo {
    width: 60%;
    max-width: 200px;
  }

  .mobile-login-title {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    font-size: 16px;
    color: #666;
  }

  .mobile-login-title div {
    padding: 0 20px;
    position: relative;
    cursor: pointer;
  }

  .mobile-login-act {
    color: #BE0022;
    font-weight: bold;
  }

  .mobile-login-act::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 3px;
    background-color: #BE0022;
    border-radius: 2px;
  }

  .mobile-login-form {
    margin-top: 20px;
  }

  .mobile-input-group {
    margin-bottom: 20px;
  }

  .mobile-input-group input {
    width: 90%;
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0 15px;
    font-size: 16px;
    outline: none;
  }

  .mobile-input-group input:focus {
    border-color: #BE0022;
  }

  .mobile-captcha-group {
    display: flex;
    gap: 10px;
  }

  .mobile-captcha-group input {
    flex: 1;
  }

  .mobile-captcha-btn {
    width: 120px;
    background-color: #BE0022;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
  }

  /* .mobile-captcha-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  } */
.mobile-captcha-btn:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  color: #fff;
}
  .mobile-login-btn {
    width: 100%;
    height: 50px;
    background-color: #BE0022;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    cursor: pointer;
  }

  .mobile-register-link {
    text-align: center;
    margin: 15px 0;
  }

  .mobile-register-link a {
    color: #0D1D76;
    font-size: 14px;
    text-decoration: none;
  }

  .mobile-notice {
    color: #BE0022;
    font-size: 12px;
    text-align: center;
    margin-top: 30px;
    line-height: 1.5;
  }
  .mobile-right-image-container{
    margin-top: 20px;
  }
  .mobile-right-image{
  width: 100%;
  height: 100%;
  object-fit: cover;
  }
}

/* PC端隐藏移动端样式 */
@media screen and (min-width: 769px) {
  .mobile-login {
    display: none;
  }
}
</style>